import {useAppDispatch, useAppSelector} from '../../hooks';
import {setAmount} from '../../features/counter/counterSlice';

interface CounterProps {
    min?: number;
    max?: number;
}

export default function Counter({min = -Infinity, max = Infinity}: CounterProps) {
    const count = useAppSelector((state) => state.counter.value);
    const dispatch = useAppDispatch();

    const buttonBaseClass = "px-4 py-2 rounded-xl shadow-sm transition font-medium";
    const buttonStyle = {
        color: 'var(--g-color-text-brand-contrast)',
        padding: '0.5rem 1rem',
        margin: '0.25rem',
    };

    const tryIncrement = (amount: number) => {
        const newCount = Math.min(count + amount, max);
        dispatch(setAmount(newCount));
    };

    const tryDecrement = (amount: number) => {
        const newCount = Math.max(count - amount, min);
        dispatch(setAmount(newCount));
    };

    return (
        <div
            className="p-6 rounded-2xl shadow space-y-4 max-w-sm mx-auto bg-[var(--g-color-base-background)] text-[var(--g-color-text-brand-contrast)]"
        >
            <h2 className="text-xl font-bold">Counter: {count}</h2>
            <div className="flex space-x-2">
                <button
                    onClick={() => tryDecrement(5)}
                    className={buttonBaseClass}
                    style={{
                        ...buttonStyle,
                        backgroundColor: 'var(--g-color-private-red-700-solid)',
                    }}
                >
                    -5
                </button>
                <button
                    onClick={() => tryDecrement(1)}
                    className={buttonBaseClass}
                    style={{
                        ...buttonStyle,
                        backgroundColor: 'var(--g-color-private-red-550-solid)',
                    }}
                >
                    -1
                </button>
                <button
                    onClick={() => tryIncrement(1)}
                    className={buttonBaseClass}
                    style={{
                        ...buttonStyle,
                        backgroundColor: 'var(--g-color-private-green-550-solid)',
                    }}
                >
                    +1
                </button>
                <button
                    onClick={() => tryIncrement(5)}
                    className={buttonBaseClass}
                    style={{
                        ...buttonStyle,
                        backgroundColor: 'var(--g-color-private-blue-550-solid)',
                    }}
                >
                    +5
                </button>
            </div>
        </div>
    );
}
